import {GetAccountResponseBody} from '@/types/payments';
import {isAccountSuccessResponse} from '.';

export const isAccountVerified = (accountResponse: GetAccountResponseBody) => {
  if (!isAccountSuccessResponse(accountResponse)) {
    return {
      isVerified: false,
      missingRequirements: {
        currently_due: [],
        past_due: [],
        pending_verification: []
      }
    };
  }

  const {charges_enabled, payouts_enabled, details_submitted, requirements} =
    accountResponse;

  const isVerified = charges_enabled && payouts_enabled && details_submitted;

  const missingRequirements = {
    currently_due: requirements.currently_due || [],
    past_due: requirements.past_due || [],
    pending_verification: requirements.pending_verification || []
  };

  return {
    isVerified,
    missingRequirements
  };
};
